'use strict';
import { EwSiteApp } from '../../app/ewsiteapp';

EwSiteApp.requires.push('flow');
EwSiteApp.requires.push('ui.bootstrap');

/* =========================
 * Main controller
 * ========================= */
EwSiteApp.controller('EsoPrCtrl', [
	'$scope', '$http', '$filter', '$uibModal', '$log',
	function ($scope, $http, $filter, $uibModal, $log) {

		$scope.dataUrl = '';
		$scope.storeUrl = '';
		$scope.items = [];
		$scope.filtered_items = [];
		$scope.sortField = 'created';
		$scope.sortReverse = true;
		$scope.currentPage = 1;
		$scope.itemsPerPage = 20;
		$scope.totalItems = 0;
		$scope.numPages;
		$scope.filter = {};
		$scope.isFilters = false;
		$scope.cars = [];
		$scope.carsUrl = '';
		$scope.fuel = [];
		$scope.fuelUrl = '';
		$scope.usersUrl = '';
		$scope.users = [];

		$scope.loadData = function () {
			if ($scope.dataUrl !== '') {
				$http({method: 'GET', url: $scope.dataUrl})
						.then(function (response) {
							var data = response.data;
							if (typeof (data.success) !== 'undefined') {
								if (data.success) {
									if (angular.isDefined(data.list)) {
										$scope.items = data.list;
										$scope.totalItems = $scope.items.length;
									}
								} else if (angular.isDefined(data.message)) {
									$scope.ewMessages.add(data.message);
								}
								if (angular.isDefined(data.debug)) {
									$log.debug(data.debug);
								}
							}
						})
						.catch(function (err) {
							$log.error('loadData failed', err);
						});
			}
		};

		$scope.loadCars = function () {
			if ($scope.carsUrl !== '') {
				$http({method: 'GET', url: $scope.carsUrl})
						.then(function (response) {
							var data = response.data;
							if (typeof (data.success) !== 'undefined') {
								if (data.success) {
									$scope.cars = data.list;
									for (var i in $scope.cars) {
										if ($scope.cars[i].filtered) {
											$scope.filter.car_id = $scope.cars[i].id;
											setTimeout(function () {
												if ($('#car_filter').length) {
													$('#car_filter').val($scope.filter.car_id).trigger('change');
												}
											}, 20);
											$scope.setFilters();
										}
									}
								}
							}
						})
						.catch(function (err) {
							$log.error('loadCars failed', err);
						});
			}
		};

		$scope.loadFuel = function () {
			if ($scope.fuelUrl !== '') {
				$http({method: 'GET', url: $scope.fuelUrl})
						.then(function (response) {
							var data = response.data;
							if (typeof (data.success) !== 'undefined') {
								if (data.success) {
									$scope.fuel = data.list;
								}
							}
						})
						.catch(function (err) {
							$log.error('loadFuel failed', err);
						});
			}
		};

		$scope.loadUsers = function () {
			if ($scope.usersUrl !== '') {
				$http({method: 'GET', url: $scope.usersUrl})
						.then(function (response) {
							var data = response.data;
							if (!angular.isUndefined(data.list)) {
								if (data.success) {
									$scope.users = data.list;
								}
							}
						})
						.catch(function (err) {
							$log.error('loadUsers failed', err);
						});
			}
		};

		$scope.addEntry = function () {
			var new_entry = {id: 0};
			$scope.editor(new_entry);
		};
		$scope.editEntry = function (entry) {
			$scope.editor(entry);
		};

		$scope.editor = function (item) {
			var template = 'esopr/returnpreview.html';
			// inicijuojant naujas perdavima arba atmesta perdavima gali redaguoti tik iniciatorius
			if (item.can_edit_rejected_return || item.id === 0) {
				template = 'esopr/returndata.html';
			}
			var modalInstance = $uibModal.open({
				templateUrl: template,
				controller: 'EsoPrEditCtrl',
				size: 'lg',
				resolve: {
					item: function () {
						return item;
					},
					filter: function () {
						return angular.copy($scope.filter);
					},
					cars: function () {
						return angular.copy($scope.cars);
					},
					fuel: function () {
						return angular.copy($scope.fuel);
					},
					users: function () {
						return angular.copy($scope.users);
					}
				}
			});

			modalInstance.result.then(function (result) {
				if ($scope.storeUrl !== '') {
					$http({
						method: 'POST',
						url: $scope.storeUrl,
						data: result,
						xsrfCookieName: secure_xsrf_name,
						xsrfHeaderName: 'X-' + secure_xsrf_name
					})
							.then(function (response) {
								var data = response.data;
								if (data.success && !angular.isUndefined(data.item)) {
									if (angular.isUndefined(item.id) || item.id < 1) {
										$scope.loadData();
									} else {
										angular.extend(item, data.item);
									}
								} else if (angular.isDefined(data.message)) {
									$scope.ewMessages.add(data.message);
								}
								if (angular.isDefined(data.debug)) {
									$log.debug(data.debug);
								}
							})
							.catch(function (err) {
								$log.error('store failed', err);
							});
				} else {
					$log.warn('No URL! url_template: ' + $scope.storeUrl);
				}
			}).catch(function (reason) {
				// swallow backdrop/esc dismiss to avoid "Possibly unhandled rejection"
				$log.debug('Editor modal dismissed:', reason);
			});
		};

		$scope.getPageList = function () {
			var ordered = $filter('filter')($scope.items, $scope.filter);
			$scope.totalItems = ordered.length;
			ordered = $filter('orderBy')(ordered, $scope.sortField, $scope.sortReverse);
			var start = ($scope.currentPage - 1) * $scope.itemsPerPage;
			var end = start + $scope.itemsPerPage;
			return ordered.slice(start, end);
		};

		$scope.cleanFilters = function () {
			$scope.filter = {car_id: ''};
			$scope.setFilters();
			setTimeout(function () {
				if ($('#car_filter').length) {
					$('#car_filter').val('').trigger('change');
				}
			}, 200);
		};

		$scope.setFilters = function () {
			$scope.isFilters = false;
			for (var i in $scope.filter) {
				if ($scope.filter[i] != '') {
					$scope.isFilters = true;
				}
			}
		};

		$scope.accept = function (item) {
			$scope.acceptEditor(item);
		};

		$scope.acceptEditor = function (item) {
			var modalInstance = $uibModal.open({
				templateUrl: 'esopr/returnaccept.html',
				controller: 'EsoPrAcceptCtrl',
				size: 'lg',
				scope: $scope,
				resolve: {
					item: function () {
						return item;
					}
				}
			});

			modalInstance.result.then(function (result) {
				if (result.action == 'reject') {
					$scope.rejectEditor(item);
				} else {
					if (item.accept_url !== '') {
						$http({
							method: 'POST',
							url: item.accept_url,
							data: result,
							xsrfCookieName: secure_xsrf_name,
							xsrfHeaderName: 'X-' + secure_xsrf_name
						})
								.then(function (response) {
									var data = response.data;
									if (data.success && !angular.isUndefined(data.item)) {
										angular.extend(item, data.item);
									} else if (angular.isDefined(data.message)) {
										$scope.ewMessages.add(data.message);
									}
									if (angular.isDefined(data.debug)) {
										$log.debug(data.debug);
									}
								})
								.catch(function (err) {
									$log.error('accept failed', err);
								});
					} else {
						$log.warn('No URL! url_template: ' + item.accept_url);
					}
				}
			}).catch(function (reason) {
				$log.debug('Accept modal dismissed:', reason);
			});
		};

		$scope.preview = function (item) {
			if (item.status == '15') {
				$scope.editor(item);
			} else {
				$scope.previewEditor(item);
			}
		};

		$scope.previewEditor = function (item) {
			var modalInstance = $uibModal.open({
				templateUrl: 'esopr/returnpreview.html',
				controller: 'EsoPrPreviewCtrl',
				size: 'lg',
				resolve: {
					item: function () {
						return item;
					}
				}
			});

			modalInstance.result.then(function (result) {
				if (item.accept_url !== '') {
					$http({
						method: 'POST',
						url: item.accept_url,
						data: result,
						xsrfCookieName: secure_xsrf_name,
						xsrfHeaderName: 'X-' + secure_xsrf_name
					})
							.then(function (response) {
								var data = response.data;
								if (data.success && !angular.isUndefined(data.item)) {
									$scope.loadData();
								} else if (angular.isDefined(data.message)) {
									$scope.ewMessages.add(data.message);
								}
								if (angular.isDefined(data.debug)) {
									$log.debug(data.debug);
								}
							})
							.catch(function (err) {
								$log.error('preview accept failed', err);
							});
				} else {
					$log.warn('No URL! url_template: ' + item.accept_url);
				}
			}).catch(function (reason) {
			});
		};

		$scope.rejectEditor = function (item) {
			var modalInstance = $uibModal.open({
				templateUrl: 'esopr/rejectpreview.html',
				controller: 'EsoPrRejectCtrl',
				size: 'lg',
				resolve: {
					item: function () {
						return item;
					}
				}
			});
			// ensure dismissals don't trigger unhandled rejection warnings
			modalInstance.result.catch(function (reason) {
				$log.debug('Reject modal dismissed:', reason);
			});
		};
	}
]).directive('returnsList', ['AddNewAction', function (AddNewAction) {
				return {
					restrict: 'A',
					link: function (scope, element, attr) {
						scope.dataUrl = '';
						scope.storeUrl = '';
						scope.carsUrl = '';
						scope.fuelUrl = '';
						scope.usersUrl = '';
						scope.itemsPerPage = 20;

						if (angular.isDefined(attr.dataUrl) && attr.dataUrl !== '') {
							scope.dataUrl = unescape(attr.dataUrl);
							scope.loadData();
						}
						if (angular.isDefined(attr.storeUrl) && attr.storeUrl !== '') {
							scope.storeUrl = unescape(attr.storeUrl);
							AddNewAction.action = function () {
								scope.addEntry();
							};
						}
						if (angular.isDefined(attr.carsUrl) && attr.carsUrl !== '') {
							scope.carsUrl = unescape(attr.carsUrl);
							scope.loadCars();
						}
						if (angular.isDefined(attr.fuelUrl) && attr.fuelUrl !== '') {
							scope.fuelUrl = unescape(attr.fuelUrl);
							scope.loadFuel();
						}
						if (angular.isDefined(attr.usersUrl) && attr.usersUrl !== '') {
							scope.usersUrl = unescape(attr.usersUrl);
							scope.loadUsers();
						}
						if (attr.itemsPerPage && attr.itemsPerPage !== '' && attr.itemsPerPage > 0) {
							scope.itemsPerPage = parseInt(attr.itemsPerPage, 10);
						}
					}
				};
			}]);

/* =========================
 * Modal: Edit
 * ========================= */
EwSiteApp.controller('EsoPrEditCtrl', [
	'$scope', '$uibModalInstance', '$filter', 'item', 'filter', 'cars', 'fuel', 'users',
	function ($scope, $uibModalInstance, $filter, item, filter, cars, fuel, users) {

		$scope.require = {car_id: true};
		$scope.item = angular.copy(item);
		$scope.cars = cars;
		$scope.car_id = 0;
		$scope.fuel = fuel;
		$scope.users = users;
		$scope.filter = filter;
		$scope.submitted = false;
		$scope.afileids = [];

		if (typeof ($scope.filter.car_id) != 'undefined') {
			$scope.item.car_id = $scope.filter.car_id;
		}

		setTimeout(function () {
			if ($('#user_select').length) {
				$('#user_select').select2({});
			}
			if ($('#fuel_select').length) {
				$('#fuel_select').select2({});
			}
		}, 200);

		$scope.save = function () {
			if ($scope.item.damage && $scope.afileids) {
				$scope.item.files = $scope.afileids;
			}
			$scope.submitted = true;
			if ($scope.classifiededitor.$valid) {
				$uibModalInstance.close($scope.item);
			}
		};
		$scope.cancel = function () {
			for (var i in $scope.require) {
				$scope.require[i] = false;
			}
			$uibModalInstance.dismiss('cancel');
		};
	}
]);

/* =========================
 * Modal: Accept
 * ========================= */
EwSiteApp.controller('EsoPrAcceptCtrl', [
	'$scope', '$http', '$log', '$uibModal', '$uibModalInstance', 'item',
	function ($scope, $http, $log, $uibModal, $uibModalInstance, item) {
		$scope.item = angular.copy(item);
		$scope.save = function () {
			$uibModalInstance.close($scope.item);
		};
		$scope.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		};
		$scope.reject = function () {
			$uibModalInstance.close({action: 'reject'});
		};
	}
]);

/* =========================
 * Modal: Preview
 * ========================= */
EwSiteApp.controller('EsoPrPreviewCtrl', [
	'$scope', '$uibModalInstance', 'item',
	function ($scope, $uibModalInstance, item) {
		$scope.item = angular.copy(item);
		$scope.save = function () {
			$uibModalInstance.close($scope.item);
		};
		$scope.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		};
	}
]);

/* =========================
 * Service
 * ========================= */
EwSiteApp.service('AddNewAction', [function () {
		this.action;
		var self = this;
		this.doAdd = function () {
			if (!angular.isUndefined(self.action)) {
				self.action();
			}
		};
	}]);

/* =========================
 * Modal: Reject
 * ========================= */
EwSiteApp.controller('EsoPrRejectCtrl', [
	'$scope', '$log', '$uibModalInstance', '$http', 'item',
	function ($scope, $log, $uibModalInstance, $http, item) {
		$scope.item = angular.copy(item);

		$scope.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		};

		$scope.reject = function () {
			if (item.rejection_url) {
				$http({
					method: 'POST',
					url: item.rejection_url,
					data: $scope.item,
					xsrfCookieName: secure_xsrf_name,
					xsrfHeaderName: 'X-' + secure_xsrf_name
				})
						.then(function (response) {
							var data = response.data;
							if (data.success) {
								$scope.cancel();
								angular.extend(item, data.item);
							} else {
								$scope.ewMessages.add(data.message);
							}
							if (data.debug) {
								$log.debug(data.debug);
							}
						})
						.catch(function (err) {
							$log.error('reject failed', err);
						});
			} else {
				$log.warn('No URL! url_template: ' + item.rejection_url);
			}
		};
	}
]);

/* =========================
 * Helpers / config
 * ========================= */
function getJsCookieValue(a) {
	var b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
	return b ? b.pop() : '';
}



EwSiteApp.controller('MultiFile', [
	'$scope', '$attrs',
	function ($scope, $attrs) {
		$scope.saveids = [];
		$scope.transmitToParent = function () {
			if (typeof ($scope.$parent.afileids) != 'undefined') {
				$scope.$parent.afileids = $scope.saveids;
			}
		};
		if ($scope.initfiles) {
			$scope.saveids = $scope.initfiles;
			$scope.transmitToParent();
		}
		$scope.$on('flow::fileSuccess', function (event, $flow, flowFile) {
			$scope.saveids.push(flowFile.response.fileId);
			$scope.showdelete = true;
			$scope.transmitToParent();
		});

		$scope.remove = function (file) {
			file.cancel();
			var indx = $scope.saveids.indexOf(file.response.fileId);
			if (indx > -1) {
				$scope.saveids.splice(indx, 1);
			}
			$scope.transmitToParent();
		};
		$scope.delete = function ($flow) {
			if ($flow.files.length > 0) {
				$flow.cancel();
			}
			$scope.initfilename = null;
			$scope.saveids = [];
			$scope.showdelete = false;
			$scope.transmitToParent();
		};
	}
]);
